// API Configuration
const API_CONFIG = {
  // Development - Local testing environment
  development: {
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5001'
  },
  // Staging - Testing environment on AWS
  staging: {
    baseURL: import.meta.env.VITE_API_URL || 'https://qiut6yug97.execute-api.us-east-1.amazonaws.com/Staging'
  },
  // Production - MAPTAC live environment
  production: {
    baseURL: import.meta.env.VITE_API_URL || 'https://4ewwyfycjj.execute-api.us-east-1.amazonaws.com/Prod'
  }
}

// Get current environment
const env = import.meta.env.MODE || 'development'

// Export the base URL for the current environment
export const API_BASE_URL = API_CONFIG[env].baseURL

// Helper function to build full API endpoints
export const buildApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`
}

// Common API endpoints
export const API_ENDPOINTS = {
  // Authentication endpoints
  AUTH_LOGIN: '/api/auth/login',
  AUTH_VERIFY_2FA: '/api/auth/verify-2fa',
  AUTH_LOGOUT: '/api/auth/logout',
  AUTH_STATUS: '/api/auth/status',
  // SSO Authentication endpoints
  AUTH_SSO_URL: '/api/auth/sso/url',
  AUTH_SSO_CALLBACK: '/api/auth/sso/callback',
  AUTH_SSO_ENABLED: '/api/auth/sso/enabled',
  // Data processing endpoints
  CONFIGURE_BIOSENSOR: '/api/configure-biosensor-upload',
  UPLOAD_PRESIGNED_URL: '/api/upload/presigned-url',
  PROCESS_COHORT_SUBJECT: '/api/process-cohort-subject',
  GET_FULL_DATASET: '/api/get-full-dataset',
  GET_DATASET_TIMELINE_RANGE: '/api/get-dataset-timeline-range',  // Just earliest/latest timestamps
  ADVANCED_PROCESS: '/api/process',
  PROCESS_STATUS: '/api/process/status',
  PROCESS_ACTIVE: '/api/process/active',
  PROCESS_CLEANUP: '/api/process/cleanup',
  STORAGE_PROCESSED_RESULTS_USAGE: '/api/storage/processed-results-usage',
  RESULTS: '/api/results',
  RESULTS_LIST: '/api/results/list',
  RESULTS_GET: '/api/results/get',
  RESULTS_DELETE: '/api/results/delete',
  RESULTS_REFRESH: '/api/results/refresh',
  DOWNLOAD_DATA: '/api/download-data',
  CURRENT_SESSION_INFO: '/api/current-session-info',
  GET_DATA_FOR_TIME_RANGE: '/api/get-data-for-time-range',
  GET_DATA_PREVIEW: '/api/get-data-preview',
  DATETIME_CONTRACT: '/api/datetime-contract',
  GET_HISTOGRAM: '/api/get-histogram',
  // Unified data revision endpoint
  REVISE_DATA: '/api/revise-data',
  // Legacy data modification endpoints (deprecated — use REVISE_DATA)
  UPDATE_DAY_LEVEL_DATA: '/api/update-day-level-data',
  UPDATE_CURVE_OVERRIDE: '/api/update-curve-override'
}

// Frontend time handling utilities (timezone-naive policy)
export const time_handling_FE = {
  // Convert a naive ISO string to ms since epoch for plotting (local interpretation)
  toMs(naiveIso) {
    if (!naiveIso) return null
    const d = new Date(naiveIso)
    const t = d.getTime()
    return isNaN(t) ? null : t
  },
  // Normalize a row to include tMs field (without mutating original)
  withMs(row) {
    const tMs = row?.datetime ? this.toMs(row.datetime) : null
    return { ...row, tMs }
  }
}

// Normalizers for API responses so downstream views/charts don't parse dates
export const normalizeTimelineRange = (respData) => {
  if (!respData) return null
  const earliest = respData.earliest || null
  const latest = respData.latest || null
  return {
    earliest,
    latest,
    earliestMs: earliest ? new Date(earliest).getTime() : null,
    latestMs: latest ? new Date(latest).getTime() : null
  }
}

export const normalizeWindowRows = (rows) => {
  if (!Array.isArray(rows)) return []
  return rows.map(r => time_handling_FE.withMs(r))
}
